export const cardEndpoints = (builder) => ({
    getCards: builder.query({
        query: ({userId}) => ({url: `/cards?userId=${userId}`, method: 'get'}),
        providesTags: ['Cards'],
    }),
    getCardTransactions: builder.query({
        query: ({userId, cardId}) => ({url: `/cards/${userId}/${cardId}/transactions`, method: 'get'}),
        providesTags: ['Cards'],
    }),
    freezeCard: builder.mutation({
        query: ({userId, cardId, cardName, meta}) => ({url: `/cards/${cardId}/freeze`, method: 'post', body: {userId, cardName, meta}}),
        invalidatesTags: ['Cards'],
    }),
    unfreezeCard: builder.mutation({
        query: ({userId, cardId, cardName, meta}) => ({url: `/cards/${cardId}/unfreeze`, method: 'post', body: {userId, cardName, meta}}),
        invalidatesTags: ['Cards'],
    }),
    downloadCardsReport: builder.mutation({
        query: ({ userId, userGroup, status, type, format }) => ({
            url: `/cards/report/${format}?userGroup=${userGroup || ""}`
                + `&userId=${userId || ""}`
                + `&type=${type || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
    downloadCardTransactionsReport: builder.mutation({
        query: ({ userId, cardId, userGroup, status, format }) => ({
            url: `/cards/transactions/report/${format}?userGroup=${userGroup || ""}`
                + `&userId=${userId || ""}`
                + `&cardId=${cardId || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
})